import { useEffect } from 'react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { captureException } from '@/lib/errorReporting';
import { UiAlert, UiButton } from '@/ui';

function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  // The data router catches render/loader errors here, so they never reach
  // the global ErrorBoundary — report them ourselves. Route error responses
  // (404s, thrown Responses) are expected and not reported.
  useEffect(() => {
    if (isRouteErrorResponse(error)) return;
    captureException(error instanceof Error ? error : new Error(String(error)), {
      source: 'RouteError',
    });
  }, [error]);

  const status = isRouteErrorResponse(error) ? error.status : 500;
  const message = isRouteErrorResponse(error) ? error.statusText : 'Unexpected router error';

  return (
    <div className='py-12'>
      <div className='max-w-2xl mx-auto px-4'>
        <UiAlert severity='error'>
          <div className='font-semibold mb-2'>{`Router Error (${status})`}</div>
          <div className='mb-4'>{message}</div>
          <div className='flex gap-3'>
            <UiButton variant='primary' onClick={() => navigate(-1)}>
              Go back
            </UiButton>
            <UiButton variant='grey' onClick={() => navigate('/')}>
              Return home
            </UiButton>
          </div>
        </UiAlert>
      </div>
    </div>
  );
}

export default RouteError;
